import React, {Component, createElement, PropTypes} from "react";
import MediaQuery from "react-responsive";
import {Link} from "react-router";

import {trackPage} from "metrics";
import {noop} from "utils";

export default class ModalLink extends Component {
  static contextTypes = {
    location: PropTypes.object,
    router: PropTypes.object,
  }
  static defaultProps = {
    component: "div",
    icon: "",
    formProps: {},
    showModal: null,
  }
  static propTypes = {
    className: PropTypes.string,
    component: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string,
    ]).isRequired,
    form: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.node,
    ]).isRequired,
    formProps: PropTypes.object,
    icon: PropTypes.string,
    label: PropTypes.string.isRequired,
    linkClassName: PropTypes.string,
    showModal: PropTypes.bool,
    style: PropTypes.object,
    url: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal || false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showModal !== null) {
      this.setState({
        showModal: nextProps.showModal,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleHideModal = (evt, onCancelled) => {
    evt && evt.preventDefault();

    if (!this._isMounted) {
      this.removeModalFromQuery();
      return;
    }
    this.setState({
      showModal: false,
    }, () => {
      this.removeModalFromQuery();
      (onCancelled || noop)();
    });
  }

  handleShowModal = (evt) => {
    evt.preventDefault();
    this.setState({
      showModal: true,
    }, () => {
      const {location: {search}} = this.context;
      const {url} = this.props;
      trackPage(`${url}${search}`);
    });
  }

  removeModalFromQuery() {
    const {location: {pathname, query}, router} = this.context;
    if (query.modal) {
      router.push({
        pathname,
        query:{
          ...query,
          modal: undefined,
        },
      });
    }
  }

  renderLabel() {
    const {icon, label} = this.props;
    if (icon) {
      return [
        <span className={`fa fa-${icon}`} key="icon" />,
        label,
      ];
    }
    return label;
  }

  renderModal() {
    if (!this.state.showModal) {
      return null;
    }
    const {form, formProps} = this.props;
    return createElement(form, {
      ...formProps,
      key: "modal",
      modal: true,
      onCancel: this.handleHideModal,
    });
  }

  render() {
    const {location: {query}} = this.context;
    const {className, component, linkClassName, style, url} = this.props;

    const linkTo = {
      pathname: url,
      query,
    };

    return createElement(component, {className, style}, [
      <MediaQuery key="mobile-link" maxWidth={768}>
        <Link className={linkClassName} to={linkTo}>
          {this.renderLabel()}
        </Link>
      </MediaQuery>,
      <MediaQuery key="desktop-link" minWidth={768}>
        <Link
          className={linkClassName}
          onClick={this.handleShowModal}
          to={linkTo}>
          {this.renderLabel()}
        </Link>
      </MediaQuery>,
      this.renderModal(),
    ]);
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/ModalLink.js
 **/